import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, GridInfo, ModuleConfigService, ResponseResult, TemplateConstant } from 'tnx-shared';
import * as FileSaver from 'file-saver';

@Injectable({
    providedIn: 'root'
})
export class AppCanBoNhanVien_DotKhamService extends BaseService {
    entityName = 'AppCanBoNhanVien_DotKham';
    serviceCode = 'sktq';

    constructor(http: HttpClient, injector: Injector,
        private _moduleConfigService: ModuleConfigService) {
        super(http, injector, `${_moduleConfigService.getConfig().environment.apiDomain.userOrgEndpoint}/AppCanBoNhanVien_DotKham`);
        this.endPoint = _moduleConfigService.getConfig().environment.apiDomain.userOrgEndpoint;
    }

    getDataChart(params): Promise<ResponseResult> {
        const url = `${this.serviceUri}/getDataChart?${new URLSearchParams(params).toString()}`;
        return this.defaultGet(url);
    }

    exportAllExcel(filters, idDotKham) {

        const gridInfo = new GridInfo({
            pageInfo: {
                page: 1,
                pageSize: 100000
            },
            filters: filters,
            sorts: []
        });

        const url = `${this.serviceUri}/ExportAllExcel/${idDotKham}`;

        return this._http
            .post(url, gridInfo, { responseType: 'blob' as 'json' })
            .toPromise()
            .then(res => {
                FileSaver.saveAs(res, this.getFullFileName('DanhSachExport'));
            }).catch(async err => {
                const errorText = await err.error.text();
                console.log(errorText);
            });
    }

    getFullFileName(fileName, extension = TemplateConstant.EXCEL_EXTENSION) {
        return `${fileName}${extension}`;
    }
}
